import * as React from "react"
import { Navigate } from "react-router-dom"

import { SCRAPING_DATA_REVIEW_ROUTES, USER_ENV, USER_ROLE } from "@constants"
import { useUserApp } from "@hooks"
import AppLayout from "Layout"
import ScrapingDataReviewPage from "./index"


/**
 * Retail only. Puig has no `dipi_olap`, and every endpoint behind this screen is
 * `@retail_env_only` — they answer 404 there.
 *
 * Two gates, because one bundle serves both deployments and the router is built
 * from the unfiltered route list: `deployments` below hides the menu entry, and
 * this redirect covers someone reaching the URL directly. `env` comes from the
 * session ('dipi' on retail, 'puig' on puig); while it is still unknown the page
 * renders and the API gate is the backstop.
 */
const ScrapingDataReviewDashboard = () => {
    const { userEnv } = useUserApp()
    if (userEnv === USER_ENV.PUIG) return <Navigate to="/" replace />
    return <ScrapingDataReviewPage />
}


export const ScrapingDataReviewRoutes = {
    path: SCRAPING_DATA_REVIEW_ROUTES.PATH,
    title: SCRAPING_DATA_REVIEW_ROUTES.TITLE,
    icon: 'spider',
    iconWeight: 'light',
    element: <AppLayout />,
    description: SCRAPING_DATA_REVIEW_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    deployments: [USER_ENV.DIPI],
    children: [{
        element: <ScrapingDataReviewDashboard />,
        index: true
    }]
}
